var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package"},[_c('p',[_c('upload',{attrs:{"data":{ category: 'qr-code' }},on:{"uploaded":_vm.onUpload},model:{value:(_vm.qrCodeUrl),callback:function ($$v) {_vm.qrCodeUrl=$$v},expression:"qrCodeUrl"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }